export default {
  isLoading: false,
  isLoadingDetail: false,
  isLoadingSubmit: false,
  isLoadingDelete: false,
  dataAll: [],
  dataList: [],
  dataForm: null,
  dataDetail: null,
  pagination: {
    currentPage: 1,
    lastPage: 1,
    count: 0,
    recordPerPage: 5,
  },
  params: {
    page: 1,
    limit: 5,
    order: 'def.created_at',
    sort: 'desc',
  },
}
